import React from 'react';
import './error-message.scss';

const ErrorMessage = ({ msg }: { msg?: string }) => {
    return msg ? <span className="error-message">{msg}</span> : null;
};

export default React.memo(ErrorMessage);
